var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "registry-editor",
      attrs: { "aria-labelledby": "registry-edit-title" },
    },
    [
      _c("h3", { staticClass: "h5", attrs: { id: "registry-edit-title" } }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _vm.kind === "license"
        ? _c("p", { staticClass: "small text-muted" }, [
            _vm._v(
              "State and license identity stay fixed. Standing is recalculated when saved."
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.baseRecord.type === "contact"
        ? _c("p", { staticClass: "small text-muted" }, [
            _vm._v(
              "Full, first and last names are stored independently. Primary and additional channels are separate fields."
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "form",
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            },
          },
        },
        [
          _vm.failure
            ? _c(
                "div",
                {
                  ref: "failure",
                  staticClass: "alert alert-danger",
                  attrs: { role: "alert", tabindex: "-1" },
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.failure) + "\n      "),
                  _vm._l(_vm.serverErrors, function (messages, key) {
                    return _c("div", { key: key, staticClass: "small" }, [
                      _vm._v(
                        _vm._s(_vm.label(key)) +
                          ": " +
                          _vm._s(messages.join(" "))
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.stale
                    ? [
                        _c("p", { staticClass: "mt-2 mb-1" }, [
                          _vm._v(
                            "Your draft is unchanged. Review current server values before starting a new edit."
                          ),
                        ]),
                        _vm.current
                          ? _c("details", [
                              _c("summary", [_vm._v("Current server values")]),
                              _c(
                                "dl",
                                [
                                  _vm._l(_vm.fields, function (field) {
                                    return [
                                      _c("dt", { key: field.key + "-key" }, [
                                        _vm._v(_vm._s(field.label)),
                                      ]),
                                      _c("dd", { key: field.key }, [
                                        _vm._v(_vm._s(_vm.currentValue(field))),
                                      ]),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.busy
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-danger mt-2",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("reload")
                            },
                          },
                        },
                        [_vm._v("Reload and discard draft")]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "fieldset",
            { attrs: { disabled: _vm.busy || !_vm.canUpdate } },
            [
              _vm.grouped
                ? _c("div", { staticClass: "small mb-3" }, [
                    _c("p", [
                      _vm._v(
                        "All parts of this address are saved together. Incomplete addresses can be saved."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary mr-2",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.groupMode = "blank"
                            _vm.blankGroup()
                          },
                        },
                      },
                      [_vm._v("Leave whole address blank")]
                    ),
                    _vm._v(" "),
                    _vm.groupFact.source === "correction"
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-outline-secondary mr-2",
                            attrs: {
                              type: "button",
                              disabled: !_vm.hasGroupSource,
                            },
                            on: {
                              click: function ($event) {
                                _vm.groupMode = "source"
                              },
                            },
                          },
                          [_vm._v("Use source address")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.changes.length
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-link",
                            attrs: { type: "button" },
                            on: { click: _vm.reset },
                          },
                          [_vm._v("Undo address change")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.groupMode === "source"
                ? _c("div", { staticClass: "border rounded p-3 mb-3" }, [
                    _c("strong", [_vm._v("Use source address")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.sourceSummary(_vm.groupFact))),
                    ]),
                  ])
                : _vm._l(_vm.groups, function (group) {
                    return _c(
                      group.disclosure ? "details" : "div",
                      {
                        key: group.key,
                        tag: "component",
                        staticClass: "mb-3",
                        attrs: {
                          "data-contact": group.key === "contact" ? "" : null,
                          "data-group": group.key,
                        },
                      },
                      [
                        group.disclosure
                          ? _c("summary", { staticClass: "small mb-2" }, [
                              _vm._v(_vm._s(group.title)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "registry-edit-grid" },
                          _vm._l(group.fields, function (field) {
                            return _c("RegistryEditField", {
                              key: field.key,
                              attrs: {
                                field: field,
                                fact: _vm.fact(field.key),
                                draft: _vm.drafts[field.key],
                                changed: !!_vm.changeFor(field),
                                error: _vm.errors[field.key] || "",
                                choices: _vm.choices(field),
                                provisional: _vm.provisional(field.key),
                                grouped: _vm.grouped,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.update(field, $event)
                                },
                                choose: function ($event) {
                                  return _vm.choose(field, $event)
                                },
                                undo: function ($event) {
                                  return _vm.undo(field)
                                },
                                "row-input": function ($event) {
                                  return _vm.inputRow(field, $event)
                                },
                                "add-row": function ($event) {
                                  return _vm.addRow(field)
                                },
                                "remove-row": function ($event) {
                                  return _vm.removeRow(field, $event)
                                },
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    )
                  }),
              _vm._v(" "),
              _vm.missingParts.length
                ? _c("p", { staticClass: "small text-warning" }, [
                    _vm._v(
                      "Missing " +
                        _vm._s(_vm.missingParts.join(", ")) +
                        " for order placement."
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "small font-weight-bold",
                  attrs: { for: "registry-edit-reason" },
                },
                [_vm._v("Reason for changes")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reason,
                    expression: "reason",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: { "is-invalid": _vm.reasonError },
                attrs: {
                  id: "registry-edit-reason",
                  required: "",
                  "aria-describedby": "registry-edit-reason-error",
                },
                domProps: { value: _vm.reason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.reason = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.reasonError
                ? _c(
                    "div",
                    {
                      staticClass: "small text-danger",
                      attrs: {
                        id: "registry-edit-reason-error",
                        role: "alert",
                      },
                    },
                    [_vm._v(_vm._s(_vm.reasonError))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.kind === "entity"
                ? _c("p", { staticClass: "small text-muted mt-3 mb-2" }, [
                    _vm._v(
                      "Changes apply wherever this " +
                        _vm._s(_vm.baseRecord.type) +
                        " is used."
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center mt-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: {
                      type: "submit",
                      disabled:
                        !_vm.changes.length ||
                        _vm.busy ||
                        _vm.stale ||
                        !_vm.baseRecord.edit_revision,
                    },
                  },
                  [_vm._v(_vm._s(_vm.busy ? "Saving…" : "Save"))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-link",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("cancel")
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "small",
                  {
                    staticClass: "text-muted ml-auto",
                    attrs: { "aria-live": "polite" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.changes.length
                          ? `${_vm.changes.length} changed`
                          : "No changes"
                      )
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              !_vm.baseRecord.edit_revision
                ? _c("p", { staticClass: "text-danger small mt-2" }, [
                    _vm._v(
                      "This record has no edit revision. Reload before saving."
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }